export const DEFAULT_SERIVCES_URL = {
  PROD: {
    MINIMEAPI: 'https://appminime.com.br/smartapi',
    MINIMETALK: 'https://appminime.com.br/smarttalk',
    MINIMEREPORT: 'https://appminime.com.br/smartreport',
  },
  HOMOLOG: {
    MINIMEAPI:
      'https://ec2-18-230-155-141.sa-east-1.compute.amazonaws.com/smartapi',
    MINIMETALK:
      'https://ec2-18-230-155-141.sa-east-1.compute.amazonaws.com/smarttalk',
    MINIMEREPORT:
      'https://ec2-18-230-155-141.sa-east-1.compute.amazonaws.com/smartreport',
  },
  DEV: {
    MINIMEAPI: 'http://localhost:8080/smartapi',
    MINIMETALK: 'http://localhost:8181/smarttalk',
    MINIMEREPORT: 'http://localhost:8282/smartreport',
  },
};

const envirioment = 'PROD';

export const DEFAULT_API_URL = DEFAULT_SERIVCES_URL[envirioment].MINIMEAPI;
export const DEFAULT_SMART_TALK_API_URL =
  DEFAULT_SERIVCES_URL[envirioment].MINIMETALK;
export const DEFAULT_SMART_REPORT_URL =
  DEFAULT_SERIVCES_URL[envirioment].MINIMEREPORT;

export const UPLOAD_STATUS = {
  PENDING: 'pending',
  UPLOADING: 'uploading',
  ERROR: 'error',
  DONE: 'done',
  PAUSE: 'paused',
};

export const COMMUNICATION_TYPE = {
  POST: 'POST',
  SURVEY: 'SURV',
  AUTHORIZATION: 'AUTH',
  ACTIVITY: 'ACTI',
  EXAM: 'EXAM',
  SCHEDULED: 'SCHE',
  OCCURRENCE: 'OCCU',
  ANALYSIS: 'ANPE',
  CALENDAR: 'CALE',
  ANTHROPOMETRIC: 'PEME',
  SCHOOL_REPORT: 'BOLE',
  PLAN: 'PLAN',
};

export const VIMEO_URL = {
  URL_VIMEO: 'https://player.vimeo.com/video/',
};

export const DEFAULT_VIMEO_THUMB =
  'https://i.vimeocdn.com/video/default_295x166?r=pad';

export const ACTION_REMOVE = 'REMOVE';

export const DEFAULT_PAGE_SIZE = 20;

export const QUESTION_TYPE = {
  SELECTION: 'MUL',
  OBJECTIVE: 'OBJ',
  TRUE_FALSE: 'VEF',
  DESCRIPTIVE: 'DES',
};

export const QUESTION_TRUE = 'V';
export const QUESTION_FALSE = 'F';

export const PERSON_TYPE = {
  LEGAL_PERSON: 'J',
  NATURAL_PERSON: 'F',
};

export const GENDERS = {
  OTHER: 'O',
  MALE: 'M',
  FEMALE: 'F',
};

export const EMPTY_HOUR = '--:--';

export const MEDICATION_APPLIED = 'MEDICATION_APPLIED';

export const TYPE_NOTIFICATIONS = {
  TYPE_DAY: 'DIA',
  TYPE_HOUR: 'HORA',
  TYPE_MINUTE: 'MINUTO',
  TYPE_WEEK: 'SEMANA',
};

export const VISIBILITY = {
  INTERNAL: 'I',
  EXTERNAL: 'E',
};

export const DAYS = {
  SUNDAY: 'DOMINGO',
  MONDAY: 'SEGUNDA',
  TUESDAY: 'TERÇA',
  WEDNESDAY: 'QUARTA',
  THURSDAY: 'QUINTA',
  FRIDAY: 'SEXTA',
  SATURDAY: 'SÁBADO',
};

export const DAYS_WEEK = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const WEEK_DAYS = [
  DAYS.SUNDAY,
  DAYS.MONDAY,
  DAYS.TUESDAY,
  DAYS.WEDNESDAY,
  DAYS.THURSDAY,
  DAYS.FRIDAY,
  DAYS.SATURDAY,
];

export const INOUT = {
  IN: '1',
  OUT: '0',
};

export const TYPE_MODAL = {
  CALENDAR: 'CALENDAR',
  EVENT: 'EVENT',
  CYCLE: 'CYCLE',
  MARKING: 'MARKING',
};

export const COLOR_PICKER = '#5300eb';

export const RUNING_ITEMS_TAB = '1';

export const FINISHED_ITEMS_TAB = '2';

export const DRIVE_MODE = {
  DRIVING: 'DRIVING',
  WALKING: 'WALKING',
  BICYCLING: 'BICYCLING',
};

export const SMARTGO_STATUS = {
  STATUS_RUNNING: 'R',
  STATUS_FINISHED: 'F',
  STATUS_CANCELED: 'C',
};

export const SMARTGO_ACCESS_CONTROL = {
  ENTRY: 'ENSAENTR',
  EXIT: 'ENSASAID',
};

export const AVAILABLE_TO = {
  ONLY_RESPONSIBLES: 'R',
  RESPONSIBLES_AND_STUDENTS: 'A',
  ONLY_STUDENTS: 'S',
};

export const COMMUNICATION_CHANNEL_TYPE = {
  INTERNAL: 'INT',
  EXTERNAL: 'EXT',
};

export const ATTACHMENT_TYPES = {
  VIMEO: 'VIMEO_VIDEO',
  YOUTUBE: 'YOUTUBE_VIDEO',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  DOC: 'DOC',
  DOCX: 'DOCX',
  XLS: 'XLS',
  XLSX: 'XLSX',
  PDF: 'PDF',
  TXT: 'TXT',
  PPT: 'PPT',
  PPTX: 'PPTX',
  PPS: 'PPS',
  PPSX: 'PPSX',
  VIDEO: 'VIDEO',
};

const ATTACHMENT_TYPES_HASH_BASE = [
  ['image/jpeg', ATTACHMENT_TYPES.IMAGE],
  ['image/png', ATTACHMENT_TYPES.IMAGE],
  ['image/jpg', ATTACHMENT_TYPES.IMAGE],
  ['image/gif', ATTACHMENT_TYPES.IMAGE],
  ['video/mp4', ATTACHMENT_TYPES.VIMEO],
  ['video/ogg', ATTACHMENT_TYPES.VIMEO],
  ['video/quicktime', ATTACHMENT_TYPES.VIMEO],
  ['audio/ogg', ATTACHMENT_TYPES.AUDIO],
  ['audio/mpeg', ATTACHMENT_TYPES.AUDIO],
  ['application/pdf', ATTACHMENT_TYPES.PDF],
  [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ATTACHMENT_TYPES.DOCX,
  ],
  [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ATTACHMENT_TYPES.XLSX,
  ],
  ['application/msword', ATTACHMENT_TYPES.DOC],
  ['application/vnd.ms-excel', ATTACHMENT_TYPES.XLS],
  ['application/vnd.ms-powerpoint', ATTACHMENT_TYPES.PPT],
  [
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ATTACHMENT_TYPES.PPTX,
  ],

  [
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    ATTACHMENT_TYPES.PPSX,
  ],
  ['text/plain', ATTACHMENT_TYPES.TXT],
];

export const ATTACHMENT_TYPES_MAP = new Map(ATTACHMENT_TYPES_HASH_BASE);

export const ATTACHMENT_TYPES_LIST = Array.from(ATTACHMENT_TYPES_MAP.keys());

export const IMAGE_COMPRESSION_DEFAULT_CONFIG = {
  maxSizeMB: 1, // (default: Number.POSITIVE_INFINITY)
  maxWidthOrHeight: 768, // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
  initialQuality: 0.75, // optional, initial quality value between 0 and 1 (default: 1)
};
export const PAYABLE = 'pagar';

export const RECEIVABLE = 'receber';

export const ACCOUNTS_FILTER_TYPE = {
  PAYABLE: 'PAYA',
  RECEIVABLE: 'RECE',
};

export const ACCOUNT_STATUS = {
  RECEIVING: 'Aberto',
  EXPIRED: 'Vencido',
};

export const RECEIPTS_TAB = '1';

export const ITEMS_TAB = '2';

export const IUGU_ACTION_NONE = 'N';

export const IUGU_ACTION_ADD = 'A';

export const IUGU_ACTION_CANCEL = 'C';

export const IUGU_ACTION_RECREATE = 'R';

export const TIPO_OPERACAO_RECEBIMENTO = 'R';

export const TIPO_OPERACAO_PAGAMENTO = 'P';

export const STATUS_OPENED = 'A';

export const STATUS_CANCELED = 'C';

export const STATUS_PARTIAL_DOWNLOADED = 'P';

export const STATUS_DOWNLOADED = 'B';

export const STATUS_CREATED = 'C';

export const STATUS_RELEASED = 'R';

export const UPDATE_RECORD_UNIQUE = 'U';

export const UPDATE_RECORD_NEXT = 'N';

export const UPDATE_RECORD_ALL = 'A';

export const ACCEPTED = 'accepted';

export const CANCEL_DEFINITIVE = 'CANC';

export const CANCEL_NEW_INOVICE = 'NEWI';

export const CANCEL_BONIFIED_INVOICE = 'BONI';

export const STATUS_SELECTOR = {
  FINISHED: 'F',
  CANCELED: 'C',
  ACTIVE: 'A',
};

export const ACCOUNT_TYPE = {
  CURRENT: 'Corrente',
  SAVINGS: 'Poupança',
};

export const POST_VISUALIZED_BY = {
  STUDENT: 'ALUN',
  RESPONSIBLE: 'RESP',
};

export const LEVEL = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
};

export const HOUR_TYPE = {
  EXACT_HOUR: 'INI',
  START_END_HOUR: 'INIFIN',
};

export const SEND_TIMELINE = {
  YES: 'S',
  NO: 'N',
  TIMELINE_WITHOUT_NOTIFICATION: 'T',
  NOTIFICATION_WITHOUT_TIMELINE: 'O',
};

export const INDIVIDUAL = 'INDI';

export const MULTIPLE = 'MULP';

export const DEFAULT_FATHER_CODE = 0;

export const DEFAULT_LEVEL = 1;

export const SUPPORTED_POST_FORMATS = [
  {
    mimeType: 'application/pdf',
    description: '.PDF',
  },

  {
    mimeType: 'image/gif',
    description: ' .GIF',
  },

  {
    mimeType: 'image/jpeg',
    description: ' .JPG',
  },

  {
    mimeType: 'image/png',
    description: ' .PNG',
  },

  {
    mimeType: 'text/plain',
    description: ' .TXT',
  },

  {
    mimeType: 'video/mp4',
    description: ' .MP4',
  },
  {
    mimeType: 'video/quicktime',
    description: ' .MOV',
  },

  {
    mimeType: 'application/msword',
    description: ' .DOC',
  },

  {
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    description: ' .DOCX',
  },

  {
    mimeType: 'application/vnd.ms-excel',
    description: ' .XLS',
  },

  {
    mimeType:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    description: ' .XLSX',
  },

  {
    mimeType: 'application/vnd.ms-powerpoint',
    description: ' .PPT',
  },
  {
    mimeType: 'application/vnd.ms-powerpoint',
    description: ' .PPS',
  },

  {
    mimeType:
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    description: ' .PPTX',
  },
  {
    mimeType:
      'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    description: ' .PPSX',
  },
];

export const WITNESS = 'Testemunha';

export const OBSERVER = 'Observador';

export const MANAGEMENT = 'Direção';

export const PAGE_TYPE = {
  C: 'C',
  N: 'N',
};

export const APPLICATION_PDF = 'application/pdf';

export const TEXT_RTF = 'text/rtf';

export const TEXT_PLAIN = 'text/plain';

export const CONTRACT = 'Contrato';

export const PERIOD_TYPE = {
  DELIVERY: 'DELIVERY',
  SCHEDULED: 'SCHEDULED',
};

export const EMPTY_STRING = '';
export const NO = 'Não';

export const URL_PDF =
  'https://appminime.com.br/smartapi/files/8f08b90e9589531f967a1b4251d3b87e7cb9f690c1920a1422';

export const FILE_TO_LARGE = 'file-too-large';

export const FILE_INVALID_TYPE = 'file-invalid-type';

export const MEGA_BYTES_1 = 1000000;

export const SMART_BABY_USER = 'SMARTBABY';

export const CHAT_CONTACT_TYPES = {
  STUDENT_RESPONSIBLE: 'ALUN',
  STUDENT_DIRECT: 'ALUN_DIRECT',
  RESPONSIBLE_DIRECT: 'RESP_DIRECT',
  EMPLOYEE: 'FUNC',
  GROUP: 'GRUP',
  COMMUNICATION_CHANNEL: 'EXT',
};

export const CHAT_RECORD_TYPE = {
  NEW_RECORDS: 1,
  OLD_RECORDS: 2,
};

export const CHAT_TYPES = {
  USER_CHAT_SCHOOL: 'ESCO',
  USER_CHAT_STUDENT: 'ALUN',
  USER_CHAT_EMPLOYEE: 'FUNC',
  USER_CHAT_GROUP: 'GRUP',
  USER_CHAT_STUDENT_DIRECT: 'ALUN_DIRECT',
};

export const REPORT_PARAMETERS = {
  REPORTTYPE: 'tipoRela',
  pCO90ALUN: 'co90Alun',
  pCO00TURM: 'co00Turm',
  pCO00MENS: 'co00Mens',
  pCO00PLEN: 'co00Plen',
  pCO90UCRE: 'senderCode',
  pCO90UCDE: 'receiverCode',
  pCO00CARD: 'co00Card',
  pDATAINIC: 'dtIni',
  pDATAFINA: 'dtFim',
  pCO00ITEM: 'co00Item',
  pCO00TITU: 'inFilter',
  pISQRCODE: 'isQrCode',
  KEY: 'key',
  pISAPP: 'isApp',
  pANO: 'ano',
  pCO90RESP: 'co90Resp',
  pCO00CONT: 'co00Cont',
  pCO00MATR: 'co00Matr',
  pSCHOOLREPORTIDS: 'idsSchoolReports',
  pCO00CURS: 'co00Curs',
  pCO01CURS: 'co01Curs',
  pCO00FUNC: 'co00Func',
  pORIGIN: 'agreement',
  pCO00COMU: 'co00Comu',
  pDATAPAGA: 'dtPag',
  pCOD_ALUNOS: 'studentIdsText',
};

export const REPORT_TYPES = {
  RELA_TROCAS: '0001',
  RELA_DIARIO: '0002',
  RELA_ANALIP: '0003',
  RELA_SONECA: '0004',
  RELA_CRESCI: '0005',
  RELA_ALTIDA: '0006',
  RELA_DIARES: '0007',
  RELA_PESIDA: '0008',
  RELA_IMCIDA: '0009',
  RELA_ALIMEN: '0010',
  RELA_ALIMFI: '0011',
  RELA_ALUTUR: '0012',
  RELA_PREALU: '0013',
  RELA_PREALUDETAIL: '0036',
  RELA_COPEAU: '0014',
  RELA_MEDICA: '0015',
  RELA_ALURES: '0016',
  RELA_CARDAP: '0017',
  RELA_PLAENS: '0018',
  RELA_MENSAG: '0019',
  RELA_FICHAA: '0020',
  RELA_BOLETI: '0021',
  RELA_CONTRA: '0023',
  RELA_CONTAS: '0024',
  RELA_CARTAO: '0025_CARTAO',
  RELA_CRACHA: '0025_CRACHA',
  RELA_ATEFRE: '0026',
  RELA_RECIBO: '0027',
  RELA_ANIVER: '0028',
  RELA_COVIDF: '0029',
  RELA_QUDE: '0030',
  RELA_TARE: '0031',
  RELA_SPAYR: '0032',
  RELA_CONTMOV: '0033',
  RELA_SCHOOLREPORT_STUDENT: '0034_STUDENT',
  RELA_SCHOOLREPORT_SUBJECT: '0034_SUBJECT',
  RELA_SCHOOLREPORT_BY_STUDENT: '0035',
  RELA_CLASS_DIARY: '0037',
  RELA_STUDENT_AGREEMENT: '0041',
  RELA_SURVEY_DETAIL: '0040',
  RELA_SURVEY_GROUP: '0038',
  RELA_EMPLOYEE_DETAILING: '0043',
  RELA_ALUNOS: '0044',
  RELA_CALEAN: '0047',
  RELA_SMRTGO: '0046',
  RELA_ACCOUNTS_RECEIVABLE: '0048',
  DEMO: 'demo',
};

export const PERMISSION_ICONS_ARRAY = [
  {
    name: 'COMUMENS',
    key: 'COMUMENS',
  },
  {
    name: 'DASHBOAR',
    key: 'DASHBOAR',
  },
  {
    name: 'DIA_APME',
    key: 'DIA_APME',
  },
  {
    name: 'DIA_PICK',
    key: 'DIA_PICK',
  },
];

export const ACTIVITY_STATUS = {
  PENDING: 'PEND',
  ANSWERED: 'RESP',
  NOT_CONCLUED: 'NCON',
  CONCLUED: 'CONC',
  REVISION: 'REVI',
};

export const AUDIO_ALERT_FILES = {
  MEDICAL:
    'https://appminime.com.br/smartapi/files/8f7105b9f93741a5346d498de4df21e38f37dff710a728949b',
  SMARTGO:
    'https://appminime.com.br/smartapi/files/f50f99308c21e549925e2a60ed790256d4fed185d8a38b4c37',
  CHAT: 'https://appminime.com.br/smartapi/files/ad3d15af75a2d6ae60241e5afb19af475aa926e57675ede9a2',
};

export const LANGUAGE_PORTUGUESE = 'PT_BR';

export const VIMEO_VIDEO_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
  TRANSCODE_STARTING: 'transcode_starting',
};

export const textEllipsis = {
  maxWidth: '10rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const BLOOD_TYPE = {
  UNIFORMED: 'N.I',
  A_PLUS: 'A+',
  A_MINUS: 'A-',
  B_PLUS: 'B+',
  B_MINUS: 'B-',
  O_PLUS: 'O+',
  O_MINUS: 'O-',
  AB_PLUS: 'AB+',
  AB_MINUS: 'AB-',
};

export const ACTION_NAME = {
  REMOVE: 'remove',
  REFRESH: 'refresh',
  ADD: 'add',
  EDIT: 'edit',
  CARD: 'card',
  PRINT: 'print',
  PRINT_RECEIPT: 'printReceipt',
  PRINT_ONE_RECEIPT: 'printOneReceipt',
  SENT: 'sent',
  APPROVE: 'approve',
  HISTORY_VIEW: 'historyView',
  REPROVE: 'reprove',
  APPLY: 'apply',
  SHOW_FILTER: 'showFilter',
  JSON_EXPORT: 'JsonExport',
  VIEW_METRICS: 'viewMetrics',
  VIEW_VISUALIZATION_METRICS: 'viewVisualizationMetrics',
  ACTIVITY_CORRECTION: 'activityCorrection',
  VIEW_TICKET: 'viewTicket',
  MORE: 'more',
  VIEW_MEDICATION_RECIPE: 'viewMedicationRecipe',
  VIEW_GRID: 'viewGrid',
  VIEW_VISUALIZATION: 'viewVisualization',
  ACCOUNT_MINUS: 'accountMinus',
  SAVE_ALT: 'saveAlt',
  CLOSE: 'close',
  VIEW: 'view',
  REPORT: 'REPORT',
};

export const ZINDEX_MATERIAL_TABLE_WITH_FILTER = 0;

export const ZINDEX_MATERIAL_TABLE_WITHOUT_FILTER = 10;

export const PERMISSION_DASHBOARD = 'RELADASH';

export const PERMISSION_FINAFINA = 'FINAFINA';

export const CONTACT_CHAT_TYPE = {
  CHANNEL: 'CHANNEL',
  STUDENT: 'STUDENT',
};

export const ACTIVE_TAB = {
  ZERO: '0',
  ONE: '1',
  TWO: '2',
  THREE: '3',
};

export const PRESENCE_TYPE = {
  PRESENT: 'P',
  LACK: 'A',
  JUSTIFIED: 'J',
  FAULTY: 'F',
};

export const FILE_EXTENSION = {
  PDF: '.PDF',
  TEXT: '.TXT',
  RTF: '.RTF',
};

export const CYCLE_TYPE = {
  A: 'A',
  S: 'S',
  T: 'T',
  B: 'B',
  M: 'M',
};

export const YEAR = {
  2019: '2019',
  2020: '2020',
  2021: '2021',
  2022: '2022',
  2023: '2023',
  2024: '2024',
};

export const DAY_ON = '1';

export const SCHOOL_TERM_TYPE = {
  LEARNING: 'Letivo',
  UN_LEARNING: 'Não Letivo',
};

export const ATTENDANCE_CONFIRMATION_STATUS = {
  NOT_ANSWERED: -1,
  CONFIRMATION_YES: 1,
  CONFIRMATION_NO: 0,
};

export const STATUS_TYPE = {
  CONCLUDED: 'CONC',
  IN_REVISION: 'REVI',
  UN_CONCLUDED: 'NCON',
  ANSWERED: 'RESP',
  PENDING: 'PEND',
};

export const STATUS_TYPE_COLOR = {
  GREEN: '#37C878',
  RED: '#D74A56',
  ORANGE: '#FFAA32',
};

export const TYPE_EVALUATION = [
  { value: 1, label: 'Somatória' },
  { value: 2, label: 'Conceitual' },
  { value: 3, label: 'Aritmética' },
];

export const FIELD_TYPE = {
  SELECT: 'SELECT',
  INPUT: 'INPUT',
};

export const TIMETABLE = {
  DISCIPLINE: 'discipline',
  HOUR: 'hour',
};

export const TEMPLATE_TYPE_COMU = 'comunicado';

export const TEMPLATE_TYPE_OCCU = 'ocorrencia';

export const TEMPLATE_APPLICATION_TYPE = {
  COMU: 'COMU',
  OCCU: 'OCCU',
};

export const SHIFT_ITEM_TYPE = {
  CLASS: 'AULA',
  INTERVAL: 'INTE',
};

export const MEDICATION_APPLICATION_STATUS = {
  APPLIED: 'APLI',
  CANCELED: 'CANC',
  PENDING: 'PEND',
};

export const EXAM_EVALUATION_TYPE = {
  SUM: 'S',
  AVG: 'A',
  CONCEPT: 'C',
};

export const SCHOOL_TERM_STATUS = {
  FINISHED: 'F',
  RELEASED: 'L',
};

export const TEACHER_ROOM_OPTION_TYPE = {
  GRADE: 'GRADE',
  PLAN: 'SURV',
  DIARY: 'AUTH',
  ACTIVITY: 'ACTI',
  CYCLE: 'CYCLE',
  OCCURRENCE: 'OCCU',
};

export const EXAM_TYPE = {
  NEW: 'N',
  RECOVERY: 'R',
  SUBSTITUTE: 'S',
};

export const EVALUATION_HEADER_TYPE = {
  COUNCIL: 'C. Classe',
  AVERAGE: 'Média',
};

export const FILTER_BY = {
  DUE_DATE: 'DUEDATE',
  PAYDAY: 'PAYDAY',
};

export const SMART_USER = {
  MANAGER: 'Administrador',
};

export const RELATION_OBJECT_TYPE = {
  SHIFT: 'TURMA',
  STUDENT: 'ALUNO',
  ALL: 'TODOS',
};

export const MATERIAL_TABLE_TYPE_VIEW = {
  GROUP: 'group',
  ROW: 'row',
};

export const REPORT_CARD_STATUS = {
  PENDING: 'PEND',
  PARTIAL: 'PART',
  FINISHED: 'FINI',
  RELEASED: 'LIBE',
};

export const CONSOLIDATION_COLUMN = {
  STUDENT: 'ST',
  SUBJECT: 'SB',
};

export const TAB = 'TAB';

export const RELEASED = 'L';

export const PENDENCY_DETAILS_TYPE = {
  APPOINTMENT: 'APPOINTMENT',
  COMMUNICATION: 'COMMUNICATION',
};
export const SCHOOL_DATA_KEY = 'DADOESCO';

export const EMPTY_MESSAGE = '';

export const FILE_TO_UPLOAD = 'FILE_TO_UPLOAD';

export const CURRENT_MESSAGES_KEY = '@currentMessages';

export const SELECTED_CONTACT_KEY = '@selectedContact';

export const SMART_TRANSITON_READINGS = '@smartSchoolTransitionReadings';

export const URL_INDICATE_PROMOTION =
  'https://materiais.smartschool.com.br/campanha-indique-e-ganhe';

export const REGEX_NO_EXPRESSIONS = /[^a-zA-ZÀ-Öà-öù-ü´`^~¨' ]/gi;

export const RECORD_FILTER_TYPE = {
  APPOINTMENT: 'APPOINTMENT',
  COMMUNICATION: 'COMMUNICATION',
};

export const STATUS_AUDIT = {
  PENDING: 'P',
};

export const COLORS = [
  '#5b346d',
  '#4db6ac',
  '#e65100',
  '#880e4f',
  '#303f9f',
  '#f8bbd0',
  '#4caf50',
  '#dce775',
  '#f6da6e',
  '#ffc107',
  '#3f51b5',
  '#90a4ae',
  '#d1c4e9',
  '#969696',
];

export const DAYS_REPEAT_ARRAY = ['0', '1', '0', '0', '0', '0', '0'];

export const DAYS_REPEAT_STRING = '0;0;0;0;0;0;0';

export const AUTHORIZATION_ANSWER = {
  AUTHORIZED: 'authorized',
  UNAUTHORIZED: 'unauthorized',
};

export const STUDENT_AGREEMENT_KEYS = {
  PRI: 'PRI',
  PUB: 'PUB',
  ALL: 'ALL',
};

export const STUDENT_AGREEMENT = (t) => {
  return [
    {
      value: STUDENT_AGREEMENT_KEYS.PRI,
      label: t(`agreement.${STUDENT_AGREEMENT_KEYS.PRI}`),
    },
    {
      value: STUDENT_AGREEMENT_KEYS.PUB,
      label: t(`agreement.${STUDENT_AGREEMENT_KEYS.PUB}`),
    },
  ];
};

export const STUDENT_AGREEMENT_ALL = (t) => {
  return [
    ...STUDENT_AGREEMENT(t),
    {
      value: STUDENT_AGREEMENT_KEYS.ALL,
      label: t(`agreement.${STUDENT_AGREEMENT_KEYS.ALL}`),
    },
  ];
};

export const LOGIN_IMAGE_DATA = {
  LINK: 'https://api.whatsapp.com/send?phone=554632350712&text=Ol%C3%A1%2C%20tenho%20interesse%20no%20Smart%20Pay.%20Gostaria%20de%20saber%20mais',
  IMG: `${process.env.PUBLIC_URL}/img/LoginBackgroundImage.png`,
  UPPER_TITLE: 'Aviso Importante',
  TITLE: 'Receba as mensalidades da sua escola sem atrasos',
  BUTTON_LABEL: 'Saiba mais',
};

export const LOCAL_IMAGES = {
  LOGO: `${process.env.PUBLIC_URL}/img/img_2.png`,
  SHORT_LOGO: `${process.env.PUBLIC_URL}/img/smartschool-short-logo.svg`,
};

export const HTML_REGEX = new RegExp(/(<([^>]+)>)/gi);

export const EXCLUDED_APPOINTMENTS = [
  { id: 87, name: 'ENTRY' },
  { id: 88, name: 'EXIT' },
  { id: 86, name: 'EXIT/ENTRY' },
];

export const OBJECT_KEYS = {
  ID: 'id',
};

export const BROWSER_LANGUAGE = {
  PT_BR: 'ptbr',
  EN_US: 'enUS',
};

export const PAGE_SIZE = {
  MIN: 5,
  DEFAULT: 20,
};

export const MEDICATION_STATUS_ENUM = {
  APPLIED: 'APPLIED',
  CANCELED: 'CANCELED',
  PENDING: 'PENDING',
};

export const APP_TYPE = {
  NOMINAL: 'Nominal',
};

export const HOURS_IN_MILLI = {
  THREE: 10800000,
};
